import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
export class BurningFruits5_2_2Screen extends SlotGameType1_2_2Screen {}